// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-container {
  color: var(--text-color);
}
.main-container img {
  width: 100%;
}
.main-container .logo {
  display: block;
  margin: 0 auto;
  max-height: 5rem;
  max-width: 25rem;
  height: auto;
  width: auto;
}
.main-container mat-divider {
  margin: 2rem;
}
.main-container .video {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
}
.main-container .video video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
}
.main-container p {
  text-align: justify;
}
.main-container button {
  width: 100%;
  margin: 0.5rem 0;
}

@media only screen and (max-width: 1279px) {
  .fxFlex-45-100md {
    flex: 1 1 100%;
    max-width: 100%;
    box-sizing: border-box;
  }
}
@media only screen and (max-width: 959px) {
  .fxhide-lt-md {
    display: none;
  }
}
@media only screen and (min-width: 1280px) {
  .fxFlex-45-100md {
    flex: 1 1 45%;
    max-width: 45%;
    box-sizing: border-box;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/company-stand/company-stand.component.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;AACF;AAAE;EACE,WAAA;AAEJ;AACE;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;AACJ;AAGE;EACE,YAAA;AADJ;AAIE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,sBAAA;AAFJ;AAII;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;AAFN;AAOE;EACE,mBAAA;AALJ;AAQE;EACE,WAAA;EACA,gBAAA;AANJ;;AAWA;EAIE;IAEE,cAAA;IACA,eAAA;IACA,sBAAA;EAZF;AACF;AAiBA;EACE;IACE,aAAA;EAfF;AACF;AAmBA;EAIE;IAEE,aAAA;IACA,cAAA;IACA,sBAAA;EArBF;AACF","sourcesContent":[".main-container {\r\n  color: var(--text-color);\r\n  img {\r\n    width: 100%;\r\n  }\r\n\r\n  .logo {\r\n    display: block;\r\n    margin: 0 auto;\r\n    max-height: 5rem;\r\n    max-width: 25rem;\r\n    height: auto;\r\n    width: auto;\r\n  }\r\n\r\n\r\n  mat-divider {\r\n    margin: 2rem;\r\n  }\r\n\r\n  .video {\r\n    position: relative;\r\n    width: 100%;\r\n    height: 0;\r\n    padding-bottom: 56.25%;\r\n\r\n    video {\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      width: 100%;\r\n      height: 100%;\r\n      border: none;\r\n    }\r\n  }\r\n\r\n\r\n  p {\r\n    text-align: justify;\r\n  }\r\n\r\n  button {\r\n    width: 100%;\r\n    margin: 0.5rem 0;\r\n  }\r\n}\r\n\r\n// Media query za site uredi pomali od 1280px (xs, sm i md uredi)\r\n@media only screen and (max-width:1279px) {\r\n\r\n\r\n  // Za site uredi\r\n  .fxFlex-45-100md {\r\n\r\n    flex: 1 1 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n\r\n  }\r\n}\r\n\r\n//  Media query za site uredi pomali od 960px (xs i sm uredi)\r\n@media only screen and (max-width: 959px) {\r\n  .fxhide-lt-md{\r\n    display: none;\r\n  }\r\n}\r\n\r\n// Media query za site uredi pogolemi od 1280px (lg i xl uredi)\r\n@media only screen and (min-width:1280px) {\r\n\r\n\r\n  // Za site uredi\r\n  .fxFlex-45-100md {\r\n\r\n    flex: 1 1 45%;\r\n    max-width: 45%;\r\n    box-sizing: border-box;\r\n\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
